import {useState} from 'react';
import PropTypes from 'prop-types';
import {IconTool} from '@gisatcz/ptr-atoms';

import './style.scss';
import ExpandableSection from '../../../atoms/ExpandableSection';

const ChartSettings = ({settingsOpen, settingItems}) => {
	const style = {
		height: settingsOpen ? `${settingItems.length * 4}rem` : 0,
	};

	return (
		<div className="insar-InterferometryChart-settings" style={style}>
			{settingItems.map((item, index) => (
				<div key={index} className="insar-InterferometryChart-settings-item">
					<span>{item.name}</span>
					<div>{item.content}</div>
				</div>
			))}
		</div>
	);
};

ChartSettings.propTypes = {
	settingItems: PropTypes.array,
	settingsOpen: PropTypes.bool,
};

const ChartControls = ({
	expanded,
	setExpanded,
	settingItems,
	settingsOpen,
	setSettingsOpen,
}) => {
	return (
		<div className="insar-InterferometryChart-controls">
			<IconTool
				icon="expand"
				active={expanded}
				onClick={() => setExpanded(!expanded)}
			/>
			{settingItems ? (
				<IconTool
					active={settingsOpen}
					icon="settings"
					onClick={() => setSettingsOpen(!settingsOpen)}
				/>
			) : null}
		</div>
	);
};

ChartControls.propTypes = {
	expanded: PropTypes.bool,
	setExpanded: PropTypes.func,
	settingItems: PropTypes.array,
	settingsOpen: PropTypes.bool,
	setSettingsOpen: PropTypes.func,
};

const Chart = ({title, settingItems, expanded, setChartExpanded, children}) => {
	const [settingsOpen, setSettingsOpen] = useState(false);

	return (
		<ExpandableSection
			className="insar-InterferometryChart"
			title={title}
			Tools={
				<ChartControls
					expanded={expanded}
					setExpanded={setChartExpanded}
					settingItems={settingItems}
					settingsOpen={settingsOpen}
					setSettingsOpen={setSettingsOpen}
				/>
			}
		>
			<>
				{settingItems?.length ? (
					<ChartSettings
						settingsOpen={settingsOpen}
						settingItems={settingItems}
					/>
				) : null}
				{children}
			</>
		</ExpandableSection>
	);
};

Chart.propTypes = {
	title: PropTypes.element,
	settingItems: PropTypes.array,
	expanded: PropTypes.bool,
	setChartExpanded: PropTypes.func,
	children: PropTypes.node,
};

export default Chart;
